/**
 * @voltxampere/ui — 1N5819 Schottky diode variant (Sprint 38-4)
 *
 * Reference: onsemi 1N5819 datasheet (DO-41 axial, 40 V / 1 A
 * Schottky rectifier — higher V_R than 1N5817).
 *   V_F ≈ 0.34 V @ I_F = 1 A
 *   I_R ≈ 5e-7 A
 *
 * Slightly higher V_F than 1N5817 (different doping for higher
 * V_R rating); reflected in saturationCurrent ≈ 3.5e-6 A.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { diode } from "../diode.js";
export const schottky1n5819 = {
    id: "1n5819",
    nameTr: "1N5819 (Schottky 1A 40V, DO41)",
    nameEn: "1N5819 (1A 40V Schottky, DO41)",
    shortcut: "D",
    category: "active",
    viewBox: diode.viewBox,
    terminals: diode.terminals,
    defaultLabel: "D",
    defaultValue: "1N5819",
    schemaType: "diode",
    defaultParams: { saturationCurrent: 3.5e-6, ideality: 1.0 },
    renderSVG: () => diode.renderSVG(),
};
//# sourceMappingURL=schottky-1n5819.js.map